export class TempConstants {
    public static TERMINATION_UNAVAILABLE_START = new Date('2025-08-29 14:00:00')
    public static TERMINATION_UNAVAILABLE_END = new Date('2025-09-01 09:00:00')
}
